import styles from './DocumentViewer.module.css';

const PDF_URL = '/assets/documents/Lucihub_Press_Release.pdf';

export default function DocumentViewer() {
  return (
    <div className={styles.viewer}>
      <embed
        src={PDF_URL}
        type="application/pdf"
        className={styles.embed}
        title="Lucihub Press Release"
      />
    </div>
  );
}
